









import * as echarts from 'echarts';
import ResizeMixin from '@/components/Charts/mixins/resize';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'qsRankingDistribution',
})
export default class extends Mixins(ResizeMixin) {
  @Prop({ default: 'bar-chart' }) public className!: string;
  @Prop({ default: '480px' }) public height!: string;
  @Prop({ default: [] }) public data!: any;

  get year() {
    return UserModule.indexSelectYear;
  }

  get language() {
    return AppModule.language;
  }

  public chart: any = null;
  public xAxis: any = [];
  public legendDataType: any[] = [];
  public valueConfigs: any[] = [];

  @Watch('language')
  @Watch('year')
  @Watch('data', { deep: true })
  public watchNum(val: any) {
    if (!this.chart) {
      this.initChart();
    }
    if (this.chart && (val === null || val === undefined || val === '')) {
      this.chart.clear();
    } else {
      const seriesData = this.getSeriesData();
      this.setEchartsOptions(seriesData);
    }
  }

  public mounted() {
    this.$nextTick(() => {
      this.initChart();
      const seriesData = this.getSeriesData();
      this.setEchartsOptions(seriesData);
    })
  }

  public beforeDestroy() {
    if (!this.chart) {
      return;
    }
    // 销毁实例，实例销毁后无法再被使用
    this.chart.dispose();
    this.chart = null;
  }

  public getSeriesData(): any[] {
    const seriesData: any[] = [];
    this.data.forEach((item: any) => {
      seriesData.push({
        value: item.num,
        name: item.institutionQsName
      })
    });
    return seriesData;
  }

  public initChart() {
    const barChartDom = this.$refs.barChartQs;
    this.chart = echarts.init(barChartDom as HTMLDivElement);
  }

  public setEchartsOptions(seriesData: any) {
    this.chart.setOption({
      tooltip: {
        trigger: 'item',
          formatter: (params: any) => {
            return `<span style="display: inline-block;background-color: ${params.color};width: 10px;height:10px;border-radius: 50%;margin-right:6px"></span><span style="color: ${params.color};">${params.name}：${params.value} (${params.percent}%)</span>`;
          },
      },
      legend: {
        top: 'center',
        right: 20,
        orient: 'vertical',
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 2
          },
          label: {
            show: true,
            fontSize: 13,
            formatter: (params: any) => {
              return `${params.percent}%`
            },
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 12,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: true,
            minTurnAngle: 45,
          },
          data: seriesData
        }
      ]
    }, {replaceMerge: ['series']});
  }
}
